
  document.addEventListener("DOMContentLoaded", () => {
  const bars = document.querySelectorAll(".announcement-bar");

  bars.forEach((bar) => {
    const wrapper = bar.querySelector(".announcement-bar__messages");
    const messages = wrapper?.querySelectorAll(".announcement-bar__message");
    const prevBtn = bar.querySelector(".announcement-prev");
    const nextBtn = bar.querySelector(".announcement-next");
    let current = 0;
    const rotationSpeed = parseInt(bar.dataset.rotationSpeed) || 0;
    let interval;

    if (!messages || messages.length <= 1) {
      prevBtn?.setAttribute("disabled", true);
      nextBtn?.setAttribute("disabled", true);
      return;
    }

    function showMessage(index) {
      messages.forEach((msg, i) => {
        msg.classList.toggle("active", i === index);
      });
      current = index;
    }

    function nextMessage() {
      showMessage((current + 1) % messages.length);
    }

    function prevMessage() {
      showMessage((current - 1 + messages.length) % messages.length);
    }

    nextBtn?.addEventListener("click", nextMessage);
    prevBtn?.addEventListener("click", prevMessage);

    if (rotationSpeed > 0) {
      interval = setInterval(nextMessage, rotationSpeed * 1000);

      wrapper.addEventListener("mouseenter", () => clearInterval(interval));
      wrapper.addEventListener("mouseleave", () => {
        interval = setInterval(nextMessage, rotationSpeed * 1000);
      });
    }
  });
});
